import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import { v4 } from 'uuid';
import styles from './ActionsModal.scss.js';
import Button from '../../../Button/Button.js';
import Modal from '../../Modal/Modal.js';

/**
 * @deprecated In favor of the new Modal of the BCL, see (https://nearpod-packages.gitlab-pages.nearpod.com/base-component-library/?path=/docs/library-modal--docs)
 */
const ActionsModal = _ref => {
  let {
    isOpen = false,
    closeButton = false,
    actionButtons,
    title,
    description,
    closeModal,
    width = 360
  } = _ref;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onClose: closeModal,
    closeButton: closeButton
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.container,
    style: {
      width: `${width}px`
    }
  }, title && /*#__PURE__*/React.createElement("p", {
    className: styles.container__title
  }, title), description && /*#__PURE__*/React.createElement("p", {
    className: styles.container__description
  }, description), /*#__PURE__*/React.createElement("div", {
    className: styles.container__buttons
  }, actionButtons.map((buttonProps, index) => /*#__PURE__*/React.createElement(Button, _extends({
    key: buttonProps.key || v4()
  }, buttonProps, {
    // The first focus will occur on the last button
    startFocused: index === actionButtons.length - 1,
    tabIndex: 0
  }))))));
};
var ActionsModal$1 = ActionsModal;

export { ActionsModal$1 as default };
//# sourceMappingURL=ActionsModal.js.map
